import { ViewGreenMarkProjectFormData } from "../data/ViewGreenMarkProjectForm.Data";
import { editGreenMarkProjectData } from "../data/editGreenMarkProject.Data";

export const setAllDropDownField = (allDropDownResponse) => {

    const filterDropDownList = (dropdownName) => {
        return allDropDownResponse.reduce((acc, item) => {
            if (item.dropdownName === dropdownName) {
                acc.push({
                    value: item.id,
                    label: item.name
                });
            }
            return acc;
        }, []);
    }

    const dropdownLists = {
        "awardRating": filterDropDownList("CPD Award Rating"),
        "gmapGreenMarkCategoryId": filterDropDownList("CPD Green Mark Category"),
        "greenMarkCategory": filterDropDownList("CPD Green Mark Category"),
        "projects": filterDropDownList("GMPVerified"),
    };

    const formFields = [
        ...editGreenMarkProjectData.formFields,
        ...ViewGreenMarkProjectFormData.formFields
    ];

    formFields.forEach(field => {
        const dropdownList = dropdownLists[field.id];
        if (dropdownList) {
            field.fieldSetting.options = dropdownList;
        }
    });
}